import React from 'react';
import { Animated } from 'react-animated-css';
import { Link } from 'react-router';
import moment from 'moment';
import config from '../../../config';
import { padWithZeros } from '../../../helpers';
import _ from 'lodash';

class WidgetArrivingToday extends React.Component {
    componentWillMount() {
        const { id } = this.props.params;
        this.props.booking_actions && this.props.booking_actions.fetch_arriving_today(id);
    }

    renderAvatar = (name, colorClass) => {
        const initial = (name || '?').charAt(0).toUpperCase();
        const isBlue = colorClass && colorClass.includes('w3-blue');
        const isYellow = colorClass && colorClass.includes('w3-yellow');
        const bg = isBlue ? '#008db5' : isYellow ? '#fdee21' : '#444';
        const fg = isYellow ? '#000' : '#fff';
        return (
            <div className="d-flex align-items-center justify-content-center rounded-circle font-14 poppins"
                style={{ width: 38, height: 38, background: bg, color: fg, flexShrink: 0, fontWeight: 600 }}>
                {initial}
            </div>
        );
    }

    render() {
        const { arriving_today } = this.props;
        const { booking_status } = config;
        const count = arriving_today ? arriving_today.length : null;

        return (
            <Animated animationIn="fadeInRight" animationInDelay={600} animationInDuration={300} className="w-100 mt-4">
                <div className="bg-gray-2 rounded px-4 py-3">

                    {/* Header */}
                    <div className="d-flex align-items-center mb-3">
                        <i className="fas fa-sign-in-alt font-20 align-self-center" style={{ color: '#008db5' }} />
                        <span className="poppins white ms-2 align-self-center" style={{ fontSize: 16, fontWeight: 600 }}>
                            Llegando hoy
                        </span>
                        <span className="poppins ms-2 align-self-center" style={{ fontSize: 13, color: '#666' }}>
                            {moment().format('dddd, DD [de] MMMM')}
                        </span>

                        {count === null && (
                            <span className="ms-auto gray">
                                <i className="fas fa-circle-notch fa-spin font-16" />
                            </span>
                        )}
                        {count !== null && (
                            <span className="ms-auto d-flex align-items-center">
                                <span className="poppins white font-12 me-1">Total:</span>
                                <span className="poppins font-20" style={{ color: count === 0 ? '#666' : '#008db5', fontWeight: 700 }}>
                                    {count}
                                </span>
                            </span>
                        )}
                    </div>

                    {/* Divider */}
                    <div style={{ height: 1, background: '#333', marginBottom: 12 }} />

                    {/* Empty state */}
                    {count === 0 && (
                        <div className="d-flex flex-column align-items-center justify-content-center py-4">
                            <i className="fas fa-door-open font-30 mb-2" style={{ color: '#444' }} />
                            <span className="poppins font-12" style={{ color: '#555' }}>
                                No hay llegadas programadas para hoy.
                            </span>
                        </div>
                    )}

                    {/* Arrivals list */}
                    {arriving_today && arriving_today.length > 0 && (() => {
                        const COL = '38px 1fr 160px 90px 90px 120px 50px';
                        return (
                            <div>
                                {/* Column headers */}
                                <div style={{ display: 'grid', gridTemplateColumns: COL, columnGap: 12, alignItems: 'center', paddingBottom: 8, marginBottom: 4, borderBottom: '1px solid #2a2a2a' }}>
                                    <div />
                                    <span className="poppins font-10" style={{ color: '#555' }}>Huésped</span>
                                    <span className="poppins font-10" style={{ color: '#555' }}>Habitación</span>
                                    <span className="poppins font-10" style={{ color: '#555' }}>Check-In</span>
                                    <span className="poppins font-10" style={{ color: '#555' }}>Check-Out</span>
                                    <span className="poppins font-10" style={{ color: '#555' }}>Estado</span>
                                    <div />
                                </div>

                                {arriving_today.map((booking, index) => {
                                    const statusObj = _.find(booking_status, t => parseInt(t.id, 10) === booking.IdStatus) || { name: '?', color_class: '' };
                                    const labeled_rooms = (booking.Rooms || []).filter(r => r.PieceLabel);
                                    const room_label = labeled_rooms.length
                                        ? labeled_rooms.map(r => r.PieceLabel).join(' • ')
                                        : null;
                                    const isLast = index === arriving_today.length - 1;

                                    return (
                                        <div key={booking.IdBook}
                                            style={{ display: 'grid', gridTemplateColumns: COL, columnGap: 12, alignItems: 'center', borderBottom: isLast ? 'none' : '1px solid #1e1e1e', paddingBottom: 10, marginBottom: 10 }}>

                                            {/* Avatar */}
                                            {this.renderAvatar(booking.GivenName, statusObj.color_class)}

                                            {/* Name + PNR */}
                                            <div className="d-flex flex-column" style={{ overflow: 'hidden' }}>
                                                <span className="poppins white" style={{ fontSize: 13, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                    {booking.GivenName}
                                                </span>
                                                <span className="poppins" style={{ fontSize: 11, color: '#666' }}>
                                                    #{padWithZeros(booking.PNR)}
                                                </span>
                                            </div>

                                            {/* Room */}
                                            <div style={{ overflow: 'hidden' }}>
                                                {room_label ? (
                                                    <span className="poppins white" style={{ fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>
                                                        <i className="fas fa-door-closed me-1" style={{ color: '#008db5', fontSize: 10 }} />
                                                        {room_label}
                                                    </span>
                                                ) : (
                                                    <span className="poppins" style={{ fontSize: 11, color: '#555' }}>—</span>
                                                )}
                                            </div>

                                            {/* Check-in time */}
                                            <span className="poppins white" style={{ fontSize: 13 }}>
                                                {moment(booking.CheckIn).format('hh:mm A')}
                                            </span>

                                            {/* Check-out date */}
                                            <span className="poppins white" style={{ fontSize: 13 }}>
                                                {moment(booking.CheckOut).format('DD/MM')}
                                            </span>

                                            {/* Status badge */}
                                            <div>
                                                <span className={`w3-tag ${statusObj.color_class} rounded px-2 poppins`} style={{ fontSize: 10, whiteSpace: 'nowrap' }}>
                                                    {statusObj.name}
                                                </span>
                                            </div>

                                            {/* Action */}
                                            <Link to={`/booking/${booking.IdBook}`}
                                                className="d-flex align-items-center justify-content-center poppins"
                                                style={{ color: '#008db5', fontSize: 13, textDecoration: 'none' }}>
                                                <i className="fas fa-eye" style={{ fontSize: 14 }} />
                                            </Link>

                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })()}

                </div>
            </Animated>
        );
    }
}

export default WidgetArrivingToday;
